import axios from "axios";
import { Fragment, useEffect, useState } from "react"
import "./Home.css";
import "./card.css"
import Potraitarts from "./Potrait-arts";
import Metadata from "./Metadata";
import Potraitslice from "../store/Potraitslice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader";

const Homepotrait = () => {
    const dispatch = useDispatch();
    const potraitvalue = useSelector((store) => {
        return store.potrait.products

    })
    const loader = useSelector((store) => {
        return store.potrait.loading

    })

    useEffect(() => {
        dispatch(Potraitslice.actions.productsrequest())
        axios.get("https://retoolapi.dev/RmS0EG/portrait_arts")
            .then(response => dispatch(Potraitslice.actions.productssuccess(response.data)))
            .catch(err => console.log(err))


    }, []);




    return (
        <Fragment>
            {loader ? <Loader> </Loader> :
                <div className="frames container">
                    <Metadata title={"Potrait-Arts-Leegifts"}> </Metadata>
                    {potraitvalue.map((ele, idx) => {
                        return (
                            <Potraitarts key={idx} img={ele.img} title={ele.title} price={ele.price} num={ele.num}>  </Potraitarts>
                        )
                    })}


                </div>}
        </Fragment>

    )


}
export default Homepotrait;